import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

import { ref } from 'vue'
import type { PropType } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { zbuContactList, zbuContactDelete, zbuContactPush } from '@/api/marketing/marketingManage'
import { useRoute } from 'vue-router'
import EditModal from './editModal.vue'
import type { ClueManage } from '@/typings/api/marketingManage'

const __default__ = { name: 'ContactsTable' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object as PropType<ClueManage['contact'][]>
  },
  contactRefId: {
    type: String
  },
  trackAcceptorClueId: {
    type: String
  },
  permissionPage: {
    type: Object
  }
},
  setup(__props, { expose: __expose }) {

const route = useRoute()
const table = ref()
const loading = ref(false)
const editModalRef = ref()
const props = __props
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.clueId) {
    zbuContactList({
      contactRefId: props.contactRefId,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
const refresh = (type?: 'add' | 'edit') => {
  if (type === 'edit') {
    table.value.fetch()
  } else {
    table.value.search()
  }
}
// const success = () => {
//   table.value.fetch()
// }
// // 新增
// const handleAdd = () => {
//   editModalRef.value.toggle()
// }
// 编辑
const handleEdit = (row: ClueManage['contact']) => {
  editModalRef.value.toggle(row)
}
// 删除
const handleDelete = (row: ClueManage['contact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      loading.value = true
      zbuContactDelete({
        contactId: row.id,
        contactRefId: row.contactRefId
      })
        .then((res) => {
          table.value.delFetch()
          message.success('删除成功')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}

const handlePush = (row: ClueManage['contact']) => {
  loading.value = true
  zbuContactPush({
    contactId: row.id,
    contactRefId: row.contactRefId,
    trackAcceptorClueId: props.trackAcceptorClueId
  })
    .then((res) => {
      table.value.fetch()
      message.success('推送成功')
    })
    .finally(() => {
      loading.value = false
    })
}

const columns = ref([
  {
    title: '联系人名称',
    dataIndex: 'name'
  },
  {
    title: '性别',
    dataIndex: 'sex',
    dicData: dataConfig.genderEnum
  },
  {
    title: '角色',
    dataIndex: 'jobRole',
    dicData: dataConfig.linkRoleTypeEnum
  },
  {
    title: '手机号',
    dataIndex: 'mobile'
  },
  {
    title: '邮箱',
    dataIndex: 'email'
  },
  {
    title: '微信号',
    dataIndex: 'wechat'
  },
  {
    title: 'QQ号',
    dataIndex: 'qq'
  },
  {
    title: '固定电话',
    dataIndex: 'tel'
  },
  {
    title: '备注',
    dataIndex: 'remark'
  }
])
__expose({
  refresh
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_table, _mergeProps({
      columns: 
      __props.disabled
        ? columns.value
        : [
            ...columns.value,
            {
              title: '操作',
              dataIndex: 'action',
              fixed: 'right',
              width: 160
            }
          ]
    ,
      onFetch: fetch
    }, _ctx.$attrs, {
      serial: "",
      ref_key: "table",
      ref: table
    }), {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleEdit(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 编辑 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, __props.permissionPage?.edit]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleDelete(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, __props.permissionPage?.del]
              ]),
              (props.trackAcceptorClueId !== undefined && props.trackAcceptorClueId !== null)
                ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (handlePush(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 推送 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_permission, __props.permissionPage?.push]
                  ])
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["columns"]),
    _createVNode(EditModal, {
      ref_key: "editModalRef",
      ref: editModalRef,
      onSuccess: refresh
    }, null, 512)
  ], 64))
}
}

})